import React, { Component }  from 'react';
import {loadingButton, loadingButtonEnd} from '../../functions';
import axios from 'axios';
import {API_URL} from '../../constants';
import ImageUploader from 'react-images-upload';
import {toBase64} from '../../functions';
import {updateValueInJson} from '../../functions';
import cookie from 'react-cookies'

export default class Compartir extends Component {

  

  constructor(props) {
    super(props);

    this.state = { 
        resource: [],
        response: [],
        error: [],
        key: 0,
        cssClass:'',
        security: cookie.load('userBulletin')
      }
      this.handleInputChange = this.handleInputChange.bind(this);
      this.onDrop = this.onDrop.bind(this);
  }

  componentDidMount() {
    var compartir = {nBoletinCodigo: this.props.clave, sTitulo:'', sEnlace:'', sNombre:'', sExtension:'', fArchivo:'', sRuta:'', nUsuarioCreacion: this.state.security.nUsuario}
    this.setState({resource: compartir});    
  }

  handleInputChange(event) {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
      
    let copyResource = JSON.parse(JSON.stringify(this.state.resource));
    copyResource[target.name] = value;
    this.setState({
        resource: copyResource
    });
  }

  handleSaveLink = async(button) =>
  {
    
      loadingButton(button, "fa-save");
      var url = `${API_URL}LinkUX/`; 
      var formData = JSON.stringify({sTitulo: this.state.resource.sTitulo, sEnlace: this.state.resource.sEnlace, nUsuarioCreacion: this.state.security.nUsuario, nBoletinCodigo: this.props.clave});
      axios.post(
        url,
        JSON.stringify(formData),
        { headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
          }
        }
        )
      .then(response => response.data)
      .then((data) => {
        loadingButtonEnd(button, "fa-save");
        document.getElementById('sTitulo').value='';
        document.getElementById('sEnlace').value='';
        document.getElementById('collapseAttachUrlSuccess').classList.add("show");
        document.getElementById('collapseAttachURL').classList.remove("show");;
      })
      .catch(error => {
      });
  }

  handleSaveUpload = async(button) =>
  {
      loadingButton(button, "fa-save");

      var url = `${API_URL}AttachUX/`; 
      var formData = JSON.stringify(JSON.stringify(this.state.resource));

      axios.post(
        url,
        formData,
        { headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
          }
        }
        )
      .then(response => response.data)
      .then((data) => {
        loadingButtonEnd(button, "fa-save");
        document.getElementById('sTitulo').value='';
        document.getElementById('sEnlace').value='';
        document.getElementById('collapseAttachFileSuccess').classList.add("show");
        document.getElementById('collapseAttachFile').classList.remove("show");;
        document.getElementById('sNombre').innerHTML='';
        document.getElementById('nameFile').innerHTML='';
        document.getElementById('sizeFile').innerHTML='';

      })
      .catch(error => {
      });
  }

  onDrop(file) {
    var index = file.length;
    if (index===0) return;
    var fileItem = file[index-1];
    
    for (var i=0; i<index; i++)
    {
      if (document.getElementsByClassName("errorMessage")[i]!==undefined){
        document.getElementsByClassName("errorMessage")[i].innerText='';
        document.getElementsByClassName("errorMessage")[i].innerHTML='';  
      }
    }  
    
    document.getElementById('nameFile').innerHTML=fileItem.name;
    document.getElementById('sizeFile').innerHTML=(fileItem.size/1024).toFixed(2) + ' Kb';
    toBase64(fileItem).catch(e => e).then(
        (data)=>
        {
            this.setState({resource:  updateValueInJson(this.state.resource, "sRuta", fileItem.name)});
            this.setState({resource:  updateValueInJson(this.state.resource, "sExtension", fileItem.type)});
            this.setState({resource:  updateValueInJson(this.state.resource, "fArchivo", data)});
        }
    );
  }

    render() {
        return ( 
            <div className="boletin__section">
                <div className="row share-info__options">
                    <div className="col-sm-6">
                        <p className="share-info__question">
                            ¿Tienes información sobre algún evento o alguna noticia que
                            quieras compartir?
                        </p>
                        <p className="share-info__indication">
                            Envianoslo y lo icluiremos en el próximo boletin
                        </p>
                    </div>
                    <div className="col-sm-3">
                      <a className="btn btn-share" data-toggle="collapse" href="#collapseAttachFile" role="button" aria-expanded="false" aria-controls="collapseShareOption">
                          <p className="btn-share__attach">
                              <i className="far fa-file-alt"></i> ADJUNTAR ARCHIVO
                          </p>
                          <p className="btn-share__restriction">Máximo 20mb</p>
                      </a>
                    </div>
                    <div className="col-sm-3">
                      <a className="btn btn-share" data-toggle="collapse" href="#collapseAttachURL" role="button" aria-expanded="false" aria-controls="collapseShareOption" >
                        <p className="btn-share__attach btn-share--url"> <i className="fas fa-link"></i> ADJUNTAR URL</p>
                      </a>
                    </div>
                  </div>
                  <div className="accordion" id="accordionOptionShare">
                    <div className="collapse showMin768" id="collapseAttachFile" data-parent="#accordionOptionShare">
                      <div className="attach-file__options card card-body">
                        <button type="button" className="popover-close close attach-file__close--mobile">
                            <span className="material-icons attach-file__close"><i className="fas fa-times-circle"></i></span>
                        </button>                
                        <div className="row align-items-center">
                          <div className="col-sm-10">
                            <div className="row attach-file__item align-items-center">
                            <div className="col-sm-6 col-12">
                                <div className="">
                                <input type="text" className="share-url__input form-control" id="sNombre" name="sNombre" placeholder="TÍTULO" onChange={this.handleInputChange} defaultValue={this.state.resource.sNombre} />
                                </div>
                              </div>

                              <div className="attach-file__name col-sm-4 col-8">
                                <ImageUploader 
                                  id="Uploader"  
                                  withLabel={false}
                                  singleImage={true}
                                  withPreview={false} 
                                  withIcon={false} 
                                  buttonText='Click para elegir archivo' 
                                  onChange={this.onDrop} 
                                  imgExtension={['.pdf', '.ppt', '.pptx', '.doc', '.docx']} 
                                  accept= {'accept=file/*'}
                                  fileSizeError={'Archivo excede el tamaño máximo'}
                                  fileTypeError={'Este tipo de archivo no está permitido'}
                                  maxFileSize={20971520}/>
                              </div>
                              <div className="attach-file__size col-sm-2 col-4">
                                <span id="nameFile"></span>
                                <br/>
                                <span id="sizeFile"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-1 col-12">
                          <button id={"btn_attach"}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleSaveUpload('attach')} >
                                <i id={"i_attach"} className="fas fa-save"></i>
                                &nbsp; ENVIAR
                            </button>
                          </div>
                          <div className="col-sm-1 col-3 text-center attach-file__close--web">
                            <a data-toggle="collapse" href="#collapseAttachFile" role="button" aria-expanded="false" aria-controls="collapseShareOption">
                              <span className="attach-file__close"><i className="fas fa-times-circle"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="collapse" id="collapseAttachURL" data-parent="#accordionOptionShare">
                      <div className="share-url__options card card-body">
                        <button type="button" className="popover-close close attach-file__close--mobile">
                          <span className="material-icons attach-file__close"><i className="fas fa-times-circle"></i></span>
                        </button>  
                        <div className="row align-items-center">
                          <div className="col-sm-4">
                            <input type="text" className="share-url__input form-control" id="sTitulo" name="sTitulo" placeholder="TÍTULO" onChange={this.handleInputChange} defaultValue={this.state.resource.sTitulo} />
                          </div>
                          <div className="col-sm-4">
                            <input type="text" className="share-url__input form-control" id="sEnlace"  name="sEnlace" placeholder="URL" onChange={this.handleInputChange} defaultValue={this.state.resource.sEnlace} />
                          </div>
                          <div className="col-sm-3 text-center">
                              <button id={"btn_link"}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleSaveLink('link')} >
                                <i id={"i_link"} className="fas fa-save"></i>
                                &nbsp; ENVIAR
                              </button>
                          </div>
                          <div className="col-sm-1 col-3 text-center attach-file__close--web"> 
                            <a className="btn btn-share" data-toggle="collapse" href="#collapseAttachURL" role="button" aria-expanded="false" aria-controls="collapseShareOption">
                              <span className="attach-file__close"><i className="fas fa-times-circle"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="collapse" id="collapseAttachFileSuccess" data-parent="#accordionOptionShare">
                      <div className="attach-file__options card card-body">
                        <div className="row align-items-center">
                          <div className="col-sm-1 col-2 text-center">
                            <span className="attach-file__check-done"><i className="far fa-check-circle"></i></span>
                          </div>
                          <div className="col-sm-10 col-8">
                            <p className="attach-file__success-msg">Muchas gracias por compartir el archivo</p>
                            <p className="attach-file__success-submsg">Revisaremos la información y si todo es correcto se incluirá en el siguiente boletín</p>
                          </div>
                          <div className="col-sm-1 col-2 text-center">
                            <a className="btn btn-share" data-toggle="collapse" href="#collapseAttachFileSuccess" role="button" aria-expanded="false" aria-controls="collapseShareOption" >
                              <span className="attach-file__close"><i className="fas fa-times-circle"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="collapse" id="collapseAttachUrlSuccess" data-parent="#accordionOptionShare">
                      <div className="share-url__options card card-body">
                        <div className="row align-items-center">
                          <div className="col-sm-1 col-2 text-center">
                            <span className="attach-file__check-done"><i className="far fa-check-circle"></i></span>
                          </div>
                          <div className="col-sm-10 col-8">
                            <p className="attach-file__success-msg">Muchas gracias por compartir</p>
                            <p className="attach-file__success-submsg"> Revisaremos la información y si todo es correcto se incluirá en el siguiente boletín</p>
                          </div>
                          <div className="col-sm-1 col-2 text-center">
                            <a className="btn btn-share" data-toggle="collapse" href="#collapseAttachUrlSuccess" role="button" aria-expanded="false" aria-controls="collapseShareOption">
                              <span className="attach-file__close"><i className="fas fa-times-circle"></i></span>
                            </a>                      
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        )
    }

}